interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <nav className="flex items-center justify-center gap-2 mt-10" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="h-10 px-3 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i>
        <span className="hidden sm:inline ml-1">上一页</span>
      </button>
      <div className="flex items-center gap-1.5">
        {pages.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`w-10 h-10 rounded-md text-sm font-label transition-colors ${
              p === page
                ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                : 'border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
            }`}
          >
            {p}
          </button>
        ))}
      </div>
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="h-10 px-3 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
      >
        <span className="hidden sm:inline mr-1">下一页</span>
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}